import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FormTableRowData from './FormTableRowData';
import FormTableCollapsedRow from './FormTableCollapsedRow';
import FormTableControlColumn from './FormTableControlColumn';

const FormTableRow = props => {
  const {
    addItem,
    canDelete,
    collapse,
    collapsed,
    collapsibleRows,
    collapsibleText,
    columns,
    form,
    getDataIndex,
    index,
    insideSection,
    numberedRows,
    primary,
    removeItem,
    rowId,
    rowSpan,
  } = props;

  const parsedCollaspibleText = () => {
    let parsedMessage = collapsibleText;
    const regex = /(\$__\S+)/g;
    const found = collapsibleText.match(regex);

    if (found && found.length) {
      found.forEach(strVar => {
        const replacement = form[strVar.replace('$__', '')] || {};
        parsedMessage = parsedMessage.replace(
          strVar,
          replacement.displayValue !== undefined ? replacement.displayValue : ''
        );
      });
    }

    return parsedMessage;
  };

  const renderControls = () => {
    return <FormTableControlColumn rowId={rowId} spanning={rowSpan} canDelete={canDelete} removeItem={removeItem} />;
  };

  const renderCounter = () => {
    return (
      <>
        <td className="index" width="1" rowSpan={rowSpan}>
          <div className="index-wrapper" />
        </td>
        {numberedRows === true || collapsibleRows === true ? (
          <td className="counter" width="1" rowSpan={rowSpan}>
            {collapsibleRows && !collapsed && (
              <div
                onClick={() => collapse(rowId)}
                className="collapse-icon minus abs-center"
                title="Collapse This Row"
              />
            )}
            {numberedRows && <div>{index + 1}</div>}
          </td>
        ) : (
          <td className="blank" width="1" rowSpan={rowSpan} />
        )}
      </>
    );
  };

  const renderRowToolbar = () => {
    const insertAbove = () => {
      const currentIndex = getDataIndex(rowId);
      addItem(currentIndex);
    };

    const insertBelow = () => {
      const currentIndex = getDataIndex(rowId);
      addItem(currentIndex + 1);
    };

    return (
      <td className="row-toolbar">
        <div className="row-menu">
          <div className="row-menu-button">
            <i className="zmdi zmdi-more-vert zmdi-hc-fw" />
          </div>
          <div className="row-menu-list">
            <div className="row-action" onClick={insertAbove}>
              <i className="zmdi zmdi-format-valign-top zmdi-hc-fw" /> Insert Above
            </div>
            <div className="row-action" onClick={insertBelow}>
              <i className="zmdi zmdi-format-valign-bottom zmdi-hc-fw" /> Insert Below
            </div>
          </div>
        </div>
      </td>
    );
  };

  const className = classNames('data-row', {
    'has-toolbar': primary && addItem,
    primary,
  });

  return (
    <tr id={`row-id-${rowId}`} className={className}>
      {insideSection === false && (
        <>
          {renderCounter()}
          {renderControls()}
        </>
      )}
      {collapsed === false ? (
        <FormTableRowData {...props} />
      ) : (
        <FormTableCollapsedRow spanning={columns.length}>
          <div onClick={() => collapse(rowId)} title="Expand This Row">
            <div className="collapse-icon float-left" style={{ marginTop: '2px' }} />
            {parsedCollaspibleText()}&nbsp;
          </div>
        </FormTableCollapsedRow>
      )}
      {primary && addItem && renderRowToolbar()}
    </tr>
  );
};

FormTableRow.defaultProps = {
  addItem: null,
  collapsed: false,
  collapsibleText: 'Collapsed',
  columns: [],
  getDataIndex: () => {},
  handleBlur: () => {},
  handleChange: () => {},
  handleClick: () => {},
  index: null,
  insideSection: false,
  numberedRows: false,
  primary: false,
  removeItem: () => {},
  rowSpan: 1,
  setInfo: () => {},
  setWarning: () => {},
};

FormTableRow.propTypes = {
  addItem: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  canDelete: PropTypes.bool.isRequired,
  collapse: PropTypes.func,
  collapsed: PropTypes.bool,
  collapsibleRows: PropTypes.bool,
  collapsibleText: PropTypes.string,
  columns: PropTypes.array,
  form: PropTypes.object.isRequired,
  getDataIndex: PropTypes.func,
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func,
  handleClick: PropTypes.func,
  index: PropTypes.number,
  insideSection: PropTypes.bool,
  numberedRows: PropTypes.bool,
  primary: PropTypes.bool,
  removeItem: PropTypes.func,
  rowId: PropTypes.number.isRequired,
  rowSpan: PropTypes.number,

  // Used to determine if a control is rendered
  setWarning: PropTypes.func,
  setInfo: PropTypes.func,
};

export default FormTableRow;
